import { createSelector } from "reselect";
import { isEmpty, forIn, isNull } from "lodash";

//EXTRACT THE PART OF THE STATE
const getData = state => {
  const userProfile = state.profile.info;
  const userPrivacy = state.profile.privacy;
  //get all static data
  const { data } = state;
  if (isEmpty(data.income)) {
    return null;
  }
  //if preference is empty return the default value
  if (isEmpty(userProfile)) {
    return null;
  }

  if (isEmpty(userPrivacy)) {
    return null;
  }
  //format the preference and return it

  if (isNull(userProfile.income)) {
    return null;
  } else {
    if (userPrivacy.income) {
      if (data.income[userProfile.income]) {
        return {
          label: data.income[userProfile.income].label,
          value: data.income[userProfile.income].value,
          description: data.income[userProfile.income].description
        };
      } else {
        return null;
      }
    } else {
      return null;
    }
  }
};
//VERIFY IF THE JWT IS SET
const getMemberIncome = createSelector(getData, birthPlace => birthPlace);
export default getMemberIncome;



// WEBPACK FOOTER //
// ./src/_selectors/profileSelectors/getMemberIncome.js